<template>
  <div
    class="federated-search-details"
    role="dialog"
    aria-modal="true"
    aria-labelledby="federated-search-details-label"
  >
    <label id="federated-search-details-label" class="sr-only"
      >Details Modal View for {{ result.title }}</label
    >
    <div class="federated-search-details__container">
      <div class="federated-search-details__inner">
        <button
          aria-label="Close Detail View"
          class="federated-search-details__close-icon"
          @click="closeModal"
          ref="closeButton"
          type="button"
        >
          <svg aria-hidden="true" role="img">
            <use
              :xlink:href="`/app/themes/ahc/src/assets/images/icons.svg#close-icon`"
            />
          </svg>
        </button>
        <div class="federated-search-details__content">
          <button
            @click="closeModal"
            class="federated-search-details__content-link"
          >
            Back to Search Results
          </button>
          <h1>{{ result.Title }}</h1>
          <p class="federated-search-details__content-sub-title">
            Quickview |
            <a
              class="federated-search-details__content-sub-title-link"
              :href="result.item_url"
              alt="Full Details"
              target="_blank"
              >Full details on {{ result.Database }} Site</a
            >
          </p>
          <p>{{ result.Description }}</p>
          <p>{{ result.Date }}</p>
          <iframe
            v-if="result.video_url"
            class="federated-search-details__video-player"
            :src="result.video_url"
            frameborder="0"
            allowfullscreen
          ></iframe>
          <ahc-federated-search-slideshow
            v-if="(this.images && this.images.length) || this.result['Pdf Url']"
            :pdf-url="this.result['Pdf Url']"
            :images="this.images"
          />

          <div class="federated-search-details__buttons">
            <a
              :href="this.detailsConfig.order_reprint_link"
              v-if="displayReprintButton"
              class="button"
              target="_blank"
              >Order Reprint</a
            >
            <a :href="this.emailLink" v-if="displayViewButton"
              >Request to View</a
            >
          </div>
          <div class="federated-search-details__details">
            <h2>Details</h2>
            <div v-for="(detail, index) in this.details()" v-bind:key="index">
              <div
                v-if="!!result[detail] && result[detail].length > 0"
                class="federated-search-details__detail-row"
              >
                <div
                  class="federated-search-details__detail federated-search-details__detail--title"
                >
                  {{ detail }}:{{ " " }}
                </div>
                <div class="federated-search-details__detail">
                  <template v-if="Array.isArray(result[detail])">
                    <p class="federated-search-details__list-detail">
                      <span v-for="(listItem, index) in result[detail]"
                        v-bind:key="index">
                        {{ listItem }}
                      </span>
                    </p>
                  </template>
                  <template v-else>
                    {{ result[detail] }}
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div
            class="federated-search-details__publisher"
            v-if="result.publisher"
          >
            <div
              class="federated-search-details__detail federated-search-details__detail--title"
            >
              Publisher
            </div>
            <p>{{ result.Publisher }}</p>
          </div>
          <p>
            You can request to view this artifact by filling out our
            <a
              :href="this.detailsConfig.patron_link"
              class="federated-search-details__link"
              >Patron Registration Form</a
            >
          </p>
          <p>
            <a
              class="federated-search-details__link"
              :href="result.item_url"
              target="_blank"
              @keydown.tab="handleTabOffFullDetails"
              alt="Full Details"
              >Full details on {{ result.Database }} Site</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import ahcFederatedSearchSlideshow from "./../federated-search-slideshow/federated-search-slideshow";

export default {
  name: 'ahc-federated-search-details',
  components: {ahcFederatedSearchSlideshow},
  methods: {
    closeModal () {
      this.close();
    },
    // Fixes accessibility tabbing when modal is open
    handleTabOffFullDetails (event) {
      event.preventDefault();
      this.$refs.closeButton.focus();
    },
    // Encode the email message passed in from the config
    emailBody() {
      return encodeURIComponent(eval('`' + this.detailsConfig.request_to_view_email_message + '`'));
    },
  },
  props: {
    close: {
      type: Function,
      required: true,
    },
    result: {
      type: Object,
      required: true,
    },
    detailsConfig: {
      type: Object
    }
  },
  data() {
    return {
      images: this.result['Pdf Url'] ? null : this.result.Images,
      videoType: this.result.video_file?.split(".").pop(),
      // Grabs the list of displayable attributes passed in from the CMS
      details () {
        return this.detailsConfig.view_attributes.split(',');
      },
      emailLink: `mailto:${this.detailsConfig.request_to_view_email}?subject=${this.detailsConfig.request_to_view_email_subject}&body=${this.emailBody()}`,
      // Boolean that determines if the reprint button should display based on a config in the CMS
      displayReprintButton: this.detailsConfig.printable_resource_format_types.split(',').includes(`${this.result.Database}:${this.result.Format}`),
      // Boolean that determines if the view on site button should display based on a config in the CMS
      displayViewButton: this.detailsConfig.viewable_resource_format_types.split(',').includes(`${this.result.Database}:${this.result.Format}`) ||
        this.detailsConfig.viewable_resource_format_types.split(',').includes(`${this.result.Database}:${this.result['Item Type']}`)
    }
  },
  mounted() {
    document.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.closeModal();
    })
    document.body.classList.add("modal-open");
    this.$nextTick(() => {
      this.$refs.closeButton.focus();
    });
  },
  unmounted() {
    document.body.classList.remove("modal-open");
  }
}
</script>

<style lang="scss">
@import "federated-search-details";
</style>
